"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.HandleReset = exports.HandleNavigateForward = exports.HandleNavigateBack = void 0;
var _material = require("@mui/material");
var _CalculatorCalculateFooter = _interopRequireDefault(require("./CalculatorCalculateFooter"));
var _CalculatorNavigationFooter = _interopRequireDefault(require("./CalculatorNavigationFooter"));
var _CalculatorForm = require("./CalculatorForm");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _function = require("../../utils/type-checks/function");
var _react = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const HandleNavigateBack = (e, dispatch, onNavigateBack) => {
    const result = {
      dispatch: false,
      onNavigateBack: false
    };
    if ((0, _function.isFunction)(dispatch)) {
      dispatch({
        type: "navigatePanelBack"
      });
      result.dispatch = true;
    }
    if ((0, _function.isFunction)(onNavigateBack)) {
      onNavigateBack(e);
      result.onNavigateBack = true;
    }
    return result;
  },
  HandleNavigateForward = (e, dispatch, onNavigateForward) => {
    const result = {
      dispatch: false,
      onNavigateForward: false
    };
    if ((0, _function.isFunction)(dispatch)) {
      dispatch({
        type: "navigatePanelForward"
      });
      result.dispatch = true;
    }
    if ((0, _function.isFunction)(onNavigateForward)) {
      onNavigateForward(e);
      result.onNavigateForward = true;
    }
    return result;
  },
  HandleReset = (e, dispatch, onReset, defaultFormState) => {
    const result = {
      dispatch: false,
      onReset: false
    };
    if ((0, _function.isFunction)(dispatch)) {
      dispatch({
        type: "resetState",
        resetStateObj: defaultFormState
      });
      result.dispatch = true;
    }
    if ((0, _function.isFunction)(onReset)) {
      onReset(e);
      result.onReset = true;
    }
    return result;
  };

/**
 * Calculator Panel Footer Component
 *
 * @visibleName Panel Footer
 * @author [Jeff Stevens](mailto:jeffrey.stevens@pheaa.org)
*/
exports.HandleReset = HandleReset;
exports.HandleNavigateForward = HandleNavigateForward;
exports.HandleNavigateBack = HandleNavigateBack;
const CalculatorPanelFooter = props => {
  const {
      children,
      className,
      dispatch,
      hideCalculate,
      onReset,
      onCalculate,
      footerStyles,
      testId,
      variant,
      ...rest
    } = props,
    isGeneric = variant !== "calculate" && variant !== "navigate",
    compositeClasses = (0, _classnames.default)({
      "calculator__panel-actions": true,
      "calculator__panel-actions--isGeneric": isGeneric,
      [`${className}`]: className
    }),
    defaultFormState = _CalculatorForm.CalculatorProviderMethods.useDefaultFormState(),
    handleReset = e => HandleReset(e, dispatch, onReset, defaultFormState);
  return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, variant === "calculate" && (0, _function.isFunction)(onCalculate) && !hideCalculate && /*#__PURE__*/_react.default.createElement(_CalculatorCalculateFooter.default, _extends({
    className: compositeClasses,
    dispatch: dispatch,
    hideCalculate: hideCalculate,
    onCalculate: onCalculate,
    handleReset: handleReset,
    testId: testId
  }, rest), children), variant === "navigate" && /*#__PURE__*/_react.default.createElement(_CalculatorNavigationFooter.default, _extends({
    className: compositeClasses,
    dispatch: dispatch,
    testId: testId,
    handleReset: handleReset
  }, rest), children), isGeneric && children && /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: compositeClasses,
    "data-testid": testId
  }, children));
};

// Define propTypes;
CalculatorPanelFooter.propTypes = {
  /** Back button text - for navigate variant only */
  backButtonText: _propTypes.default.string,
  /** Calculate button text - for calculate variant only */
  calculateButtonText: _propTypes.default.string,
  /** Custom child actions fragment/component */
  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node, _propTypes.default.string]),
  /** Optional class name(s) */
  className: _propTypes.default.string,
  /** Boolean to deactive default button */
  disableDefault: _propTypes.default.bool,
  /** Dispatch Function */
  dispatch: _propTypes.default.func.isRequired,
  /** Boolean to hide back button - for navigate variant only */
  hideBack: _propTypes.default.bool,
  /** Boolean to hide calculate button - for calculate variant only */
  hideCalculate: _propTypes.default.bool,
  /** Boolean to hide navigate forward button - for navigate variant only */
  hideNavigateButton: _propTypes.default.bool,
  /** Boolean to hide reset button */
  hideReset: _propTypes.default.bool,
  /** Navigate next button text - for navigate variant only */
  navigateButtonText: _propTypes.default.string,
  /** Calculation method - for calculate variant only */
  onCalculate: _propTypes.default.func,
  /** Custom navigate back method - for navigate variant only */
  onNavigateBack: _propTypes.default.func,
  /** Custom navigate next method - for navigate variant only */
  onNavigateForward: _propTypes.default.func,
  /** Custom reset method */
  onReset: _propTypes.default.func,
  /** Reset button text */
  resetButtonText: _propTypes.default.string,
  /** @ignore */
  testId: _propTypes.default.string,
  /** Variant type */
  variant: _propTypes.default.oneOf(["calculate", "generic", "navigate"])
};

// Export component as default;
var _default = exports.default = CalculatorPanelFooter;